// src/store/actions/garageActions.js
import { GARAGE_ACTION_TYPES } from './actionTypes';
import garageService from '../../services/garageService';

// Fetch garages
export const fetchGarages = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.FETCH_GARAGES_REQUEST });

    const response = await garageService.fetchGarages(filters);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_GARAGES_SUCCESS,
      payload: {
        garages: response.data,
        pagination: response.meta,
      },
    });
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_GARAGES_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch garages',
    });
  }
};

export const fetchMakes = () => async (dispatch) => {
  try {
    const response = await garageService.fetchVehicleMakes();

    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_MAKES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_MAKES_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch vehicle makes',
    });
  }
};

// Fetch single garage
export const fetchGarageById = (id) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.FETCH_GARAGE_REQUEST });

    const response = await garageService.fetchGarageById(id);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_GARAGE_SUCCESS,
      payload: response.data,
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_GARAGE_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch garage',
    });
  }
};

// Create garage
export const createGarage = (garageData) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.CREATE_GARAGE_REQUEST });

    const response = await garageService.createGarage(garageData);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.CREATE_GARAGE_SUCCESS,
      payload: {
        message: 'Garage created successfully',
        garage: response.data,
      },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.CREATE_GARAGE_FAIL,
      payload: error.response?.data?.message || 'Failed to create garage',
    });
  }
};

// Update garage
export const updateGarage = (id, garageData) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.UPDATE_GARAGE_REQUEST });

    const response = await garageService.updateGarage(id, garageData);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.UPDATE_GARAGE_SUCCESS,
      payload: {
        message: 'Garage updated successfully',
        garage: response.data,
      },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.UPDATE_GARAGE_FAIL,
      payload: error.response?.data?.message || 'Failed to update garage',
    });
  }
};

// Delete garage
export const deleteGarage = (id) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.DELETE_GARAGE_REQUEST });

    await garageService.deleteGarage(id);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.DELETE_GARAGE_SUCCESS,
      payload: {
        message: 'Garage deleted successfully',
        id,
      },
    });
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.DELETE_GARAGE_FAIL,
      payload: error.response?.data?.message || 'Failed to delete garage',
    });
  }
};

// Update approval status
export const updateApprovalStatus = (id, status) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.UPDATE_APPROVAL_REQUEST });

    const response = await garageService.updateApprovalStatus(id, status);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.UPDATE_APPROVAL_SUCCESS,
      payload: {
        message: `Garage ${status.toLowerCase()} successfully`,
        garage: response.data,
      },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.UPDATE_APPROVAL_FAIL,
      payload: error.response?.data?.message || 'Failed to update approval status',
    });
  }
};

// Add review
export const addReview = (id, reviewData) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.ADD_REVIEW_REQUEST });

    const response = await garageService.addReview(id, reviewData);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.ADD_REVIEW_SUCCESS,
      payload: {
        message: 'Review added successfully',
        review: response.data,
      },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.ADD_REVIEW_FAIL,
      payload: error.response?.data?.message || 'Failed to add review',
    });
  }
};

// Bulk import
export const bulkImportGarages = (garages) => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.BULK_IMPORT_REQUEST });

    const response = await garageService.bulkImport(garages);
    
    dispatch({
      type: GARAGE_ACTION_TYPES.BULK_IMPORT_SUCCESS,
      payload: {
        message: `Imported ${response.data.success.length} garages`,
        result: response.data,
      },
    });
    
    return response.data;
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.BULK_IMPORT_FAIL,
      payload: error.response?.data?.message || 'Failed to bulk import garages',
    });
  }
};

// Fetch statistics
export const fetchStatistics = () => async (dispatch) => {
  try {
    dispatch({ type: GARAGE_ACTION_TYPES.FETCH_STATISTICS_REQUEST });

    const response = await garageService.fetchStatistics();
    
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_STATISTICS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GARAGE_ACTION_TYPES.FETCH_STATISTICS_FAIL,
      payload: error.response?.data?.message || 'Failed to fetch statistics',
    });
  }
};

// Clear error
export const clearGarageError = () => ({
  type: GARAGE_ACTION_TYPES.CLEAR_GARAGE_ERROR,
});

// Clear success
export const clearGarageSuccess = () => ({
  type: GARAGE_ACTION_TYPES.CLEAR_GARAGE_SUCCESS,
});

// Clear state
export const clearGarageState = () => ({
  type: GARAGE_ACTION_TYPES.CLEAR_GARAGE_STATE,
});